<template>
    <section class="message-item">
        <span class="point-in-time"></span>
        <div class="time">
            <span>{{parsedDateDistance}}前</span>
            <span>{{parsedType}}</span>
        </div>
        <div class="content round-corner">
            <div v-if="showUserLink" class="sender-wrap" @click="senderClick">
                <van-image
                        round lazy-load fit="cover"
                        width="24px" height="24px"
                        :src="getAvatarByUUID(item.si.uuid)"
                />
                <h3 class="sender link">
                    {{senderName}}
                </h3>
            </div>

            <p v-html="item.c"></p>

            <p v-for="(extra, index) in parsedExtras" :key="index">
                {{extra.key}}：{{extra.value}}
            </p>

            <div class="btn-wrap">
                <span class="btn-detail" v-if="item.mbUrl" @click="locationTo(item.mbUrl)">查看详情</span>
            </div>
        </div>
    </section>
</template>

<script>
    import {Image} from 'vant'
    import {getAvatarByUUID} from "@/utils/commons";
    import {locationTo} from "@/utils/url";
    import {formatDateTimeToNow} from "@/utils/dateTimeUtil"

    export default {
        name: 'MessageItem',
        components: {
            [Image.name]: Image
        },
        props: ['item', 'showUserLink'],
        data() {
            return {}
        },
        computed: {
            parsedDateDistance() {
                return formatDateTimeToNow(this.item.st)
            },
            senderName() {
                return this.item.mc != 'QUANZI_ANONYMOUS_COMMENT' && this.item.si && this.item.si.userName
            },
            parsedExtras() {
                return this.item.extras || []
            },
            parsedType() {
                let parsedType = ""
                const type = this.item.mc || ''
                if (type == 'COOPERATE') {	// 事项 : 待办，已处理，
                    parsedType = '办公事项'
                } else if (type == 'COOPERATE_HAVETODO') {//终止了协同、代替您终止了协同，暂存了您的协同，
                    parsedType = '办公事项'
                } else if (type == 'COOPERATE_HAVEHAIR') {//协同催办
                    parsedType = '办公事项'
                } else if (type == 'COOPERATE_REPLY') {//协同回复
                    parsedType = '办公事项'
                } else if (type == 'COOPERATION-MONITOR') {//流程智能监测
                    parsedType = '办公事项'
                } else if (type == 'ANNOUNCEMENT' || type == 'ANNOUNCEMENT_TEXT' || type == 'ANNOUNCEMENT_SUPPLY') {	// 公告
                    parsedType = '通知助手'
                } else if (type == 'SURVEY') {	// 调查
                    parsedType = '调查信息'
                } else if (type == 'MEETING') {	// 会议
                    parsedType = '会议信息'
                } else if (type.indexOf("MEET") != -1) {	// 会议
                    parsedType = '会议助手'
                } else if (type == 'REVOKE_MEETING') {//撤销会议
                    parsedType = "撤销会议"
                } else if (type == 'SCHEDULER') { //日程
                    parsedType = '日程'
                } else if (type == 'NETDISK') {	// 网盘
                    parsedType = '资料共享'
                } else if (type == 'TASK' || type == 'TIMEOUT_TASK') {	// 任务
                    //任务的businessId格式："main/receive/"+taskSub.getTaskTypeId()+"/"+taskSub.getMainTaskId()+"/"+taskSub.getSubTaskId()+"/msg")
                    //通知接收人
                    parsedType = '任务'
                } else if (type == 'SHIXI') {	// 校外实习
                    //通知教师
                    parsedType = '校外实习'
                } else if (type == 'JIATIAO_MESSAGE_FOR_STUDENT' || type == 'JIATIAO_MESSAGE_FOR_FDY') {// 电子假条(当学期逾期销假时给学生，辅导员发送的消息提醒)
                    parsedType = '请假详情'
                    //查询详情的可以进协同该条请假记录
                } else if (type == 'CREDIT') {	// 德育评测
                    parsedType = '德育评测'
                } else if (type == 'TMKAOQIN') {	// 学生课表
                    parsedType = '学生课表'
                } else if (type == 'LOSTFOUNDAUDIT') { //实物招领
                    parsedType = '失物招领审核'
                } else if (type == 'INFORMATIONAUDIT') {//校园互助
                    parsedType = '校园互助审核'
                } else if (type == 'SERVICEHALL_APPOINTMENT') {//服务预约
                    parsedType = '在线预约'
                } else if (type == 'ZAIXIANXUEXI_DJ' || type == 'ZAIXIANXUEXI_JY') {//在线考试
                    parsedType = '在线考试'
                } else if (type == 'ENROLLMENT') {//迎新服务
                    parsedType = '迎新服务'
                } else if (type == 'RES') { //公共资源预约
                    parsedType = '公共资源预约'
                } else {
                    parsedType = '系统消息'
                }
                return parsedType
            },
        },
        methods: {
            locationTo, getAvatarByUUID,
            senderClick() {
                if (this.showUserLink)
                    this.$router.push({
                        path: "/messageList",
                        query: {
                          uid: this.item.si.userId,
                          uuid: this.item.si.uuid
                        }
                    });
            }
        }
    }
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";
    .message-item {
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        position: relative;
        margin: 0 15px 10px;
        padding: 0 0 0 18px;

        &:after {
            content: '';
            display: block;
            width: 1px;
            height: 100%;
            background-color: var(--main-color);
            position: absolute;
            left: 0;
            top: 20px;
        }

        &:last-of-type:after {
            display: none;
        }

        .time {
            height: 30px;
            line-height: 30px;
            color: #999;
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-start;
            @extend .font12;

            span:first-child {
                margin-right: 5px;
            }
        }

        .point-in-time {
            position: absolute;
            left: -8px;
            top: 8px;
            z-index: 8;
            display: block;
            width: 13px;
            height: 13px;
            border-radius: 50%;
            border: 1px solid var(--main-color);
            background: #fff;
        }

        .point-in-time:after {
            position: absolute;
            left: 2px;
            top: 2px;
            z-index: 7;
            content: "";
            display: block;
            width: 9px;
            height: 9px;
            border-radius: 50%;
            background: var(--main-color);
        }
    }

    .content {
        padding: 10px 15px;
        background-color: #ffffff;

        .sender-wrap {
            display: flex;
            align-items: center;
            border-radius: 2px;
            margin-bottom: 5px;

            &:active {
                background-color: lighten(#000000, 96%);
            }

            .sender {
                display: inline-block;
                color: lighten(#000000, 15%);
                font-weight: 400;
                margin-left: 5px;
                @extend .font14;

                &.link {
                    color: var(--main-color);
                }
            }
        }

        p {
            margin-bottom: 5px;
            line-height: 1.6;
            color: lighten(#000000, 35%);
            font-weight: 400;
            text-align: justify;
            word-break: break-all;
            @extend .font14;
        }

        .btn-wrap {
            text-align: right;

            .btn-detail {
                color: var(--main-color);
                padding: 3px 10px;
                margin: -5px;
                border-radius: 2px;
                @extend .font12;

                &:active {
                    background-color: lighten(#000, 96%);;
                }
            }
        }
    }
</style>
